module.exports = __webpack_public_path__ + "static/art-21bee459caf9a9aa70ed33dba900c121.png";